import React from "react";
import ReactDOM from "react-dom/client";
import htmlToDom from "html-react-parser";
class LanguageMenu extends React.Component {
  render() {
    let urlAlternates = [],
      type = this.props.type;
    let useGoogleTranslate = true;
    if ($("[hreflang|='x-default']").length > 0) {
      useGoogleTranslate = false;
    }
    $(app_locales).each(function (index, thisLocale) {
      urlAlternates[thisLocale] = $("[hreflang|='" + thisLocale + "']").length
        ? $("[hreflang|='" + thisLocale + "']")
            .eq(0)
            .attr("href")
        : thisLocale == lang
          ? window.location
          : window.Routing.generate("_homepage_" + portal + "." + thisLocale);
    });
    let menu = <div id="gte" className="minw-200"></div>;
    if (!useGoogleTranslate) {
      let menuItems = "";
      $(app_locales).each(function (index, thisLocale) {
        menuItems +=
          '<a tabIndex="-1" title="' +
          window.Translator.trans("locale.switch", {}, "js") +
          ": " +
          window.Translator.trans("locale.languages." + thisLocale, {}, "js") +
          '"' +
          ' data-hreflang="' +
          thisLocale +
          '" href="' +
          urlAlternates[thisLocale] +
          '" aria-label="' +
          window.Translator.trans("locale.languages." + thisLocale, {}, "js") +
          '">' +
          '<svg className="icon black circle shadow" width="24" height="24"><use href="#flag-' +
          (thisLocale == "de" && portal == "MZAT" ? "at" : thisLocale) +
          '"></use></svg>' +
          //  '<i className="me-1 flag flag-'+ (thisLocale == 'de' && portal == 'MZAT' ? 'at' : thisLocale) +'"></i>'+
          window.Translator.trans("locale.languages." + thisLocale, {}, "js") +
          "</a>";
      });
      if (menuItems.length) {
        menu = <>{htmlToDom(menuItems)}</>;
      }
    }
    return <>{menu}</>;
  }
}

let langEl = document.getElementById("lang-options");
if (langEl !== null) {
  const langElRoot = ReactDOM.createRoot(langEl);
  langElRoot.render(
    <LanguageMenu
      type={langEl.className.match("/\blogged-in\b/") ? "logged-in" : "public"}
    />
  );
}
